import $ from "jquery";

const makePagesArray = (start_page, end_page) => {
  const array = [];
  for (var i = start_page; i <= end_page; i++) {
    array.push(i);
  }
  return array;
};

let handlePaginationClick, updateHtml; // ESLint complains no-use-before-define when dealing with mutually recursive functions;
handlePaginationClick = e => {
  if ($($(e.target).closest("li")).hasClass("disabled")) return;
  const clickedPage = Number($($(e.target).closest("li")).data("target-page"));
  const baseLink = $(e.target).closest(".pagination-controls").find("a").attr("href");
  $.get(`${baseLink}&page=${clickedPage}`, data => {
    // TODO: Find a way to persist page across page refresh
    // window.localStorage.setItem("currentPage", data.page);
    updateHtml(data);
  });
};

updateHtml = data => {
  let htmlToReturn = "";
  if (!data.items.length) {
    htmlToReturn += "<h3 class=\"no-results\">Your search did not bring back any results</h3>";
  } else {
    data.items.forEach(resultArray => {
      const [record, result] = resultArray;
      let type;
      switch (result.type) {
      case "ArticleWrapper":
        type = "Article";
        break;
      case "Organisation":
        type = result.utility ? "Utility" : "Company";
        break;
      case "Record":
        type = `Record / ${record.data_hub_record}`;
        break;
      default:
        type = result.type;
      }
      let subheading = "";
      if (result.type === "ArticleWrapper") {
        subheading = `
          <div class="result-type">${result.subheading}</div>
        `;
      }
      let { path } = result;
      let spanOrAStart = `<a href="${path}" class="card-link">`;
      let spanOrAEnd = "</a>";
      if (!path || path === "nolink") {
        spanOrAStart = "<span class='card-link'>";
        spanOrAEnd = "</span>";
      }

      const resultHtml = `<div class="col-md-12">
      <div class="card search-heading tag">
        ${spanOrAStart}
          <div class="result-type-icon">
            <img src="${result.icon_src}" />
          </div>
          <div class="text-content">
            <div class="result-type">${type}</div>
            ${subheading}
            <h3 class="card-title"> ${result.content}</h3>
            ${record.content_for_global_search || ""}
            ${result.highlights}
          </div>
        ${spanOrAEnd}
      </div></div>`;
      htmlToReturn += resultHtml;
    });
  }
  const $paginationControls = $("#main-container .container-fluid").find(".pagination-controls").clone();
  $paginationControls.find("a").attr("href", data.path);
  $paginationControls.on("click", handlePaginationClick);
  const [firstPage, finalPage, previousPage, nextPage] = [
    data.first_page,
    data.final_page,
    data.page - 1,
    data.page + 1
  ];
  let pages;
  if (finalPage <= 10) {
    pages = makePagesArray(firstPage, finalPage);
  } else if (data.page - 5 <= 0) {
    pages = makePagesArray(firstPage, data.page + 4).concat(["...", finalPage]);
  } else if (data.page + 5 >= finalPage) {
    pages = [firstPage, "..."].concat(makePagesArray(data.page - 4, finalPage));
  } else {
    pages = [firstPage, "..."].concat(makePagesArray(data.page - 4, data.page + 4)).concat(["...", finalPage]);
  }
  const $paginationUl = $paginationControls.find("ul");
  $paginationUl.empty();
  $paginationUl.append($(`<li data-target-page="${previousPage}" class="${previousPage < firstPage ? "disabled" : ""}">Previous</li>`));
  pages.forEach(page => {
    if (page == "...") {
      $paginationUl.append($(`<li>${page}</li>`));
    } else {
      $paginationUl.append($(`<li data-target-page="${page}" class="${Number(page) == data.page ? "active" : ""}">${page + 1}</li>`));
    }
  });
  $paginationUl.append($(`<li data-target-page="${nextPage}" class="${nextPage > finalPage ? "disabled" : ""}">Next</li>`));
  $("#main-container .container-fluid").empty().append($(htmlToReturn)).append($paginationControls);
};

const handleSectionClick = e => {
  e.preventDefault();

  const $clickedSection = $($(e.target).closest(".section"));
  $.get(`${$clickedSection.find("a").attr("href")}.json`, data => {
    $("#sections-nav-container").find("li.section.active").removeClass("active");
    $clickedSection.addClass("active");

    updateHtml(data);
  });
};

$(document).on("turbolinks:load", () => {
  const $globalSearchSections = $(".global-search-heading").siblings("#sections-nav-container").first();
  if (!$globalSearchSections.length) return;

  $globalSearchSections.find("li.section").on("click", handleSectionClick);
  $(".pagination-controls li").on("click", handlePaginationClick);
});
